enum Granularity {
    raw = 'Raw',
    hourly = 'Hourly',
    daily = 'Daily',
    monthly = 'Monthly',
    yearly = 'Yearly'
}

export default Granularity;